module.exports = __webpack_public_path__ + "img/button_diameter.2ec30a57.png";